"use client";
import {
  ChevronsUpDown,
  LogOut,
  // Moon, Palette, Sun
} from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  // DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarMenuButton } from "@/components/ui/sidebar";
import { NavigationMenuItem } from "./ui/navigation-menu";
import { singOutUser } from "@/app/actions/signOutUser";

const getFullNameInitials = (fullname: string) => {
  const nameParts = fullname.split(" ");

  if (nameParts.length === 1) {
    return `${fullname[0]}${fullname[1]}`.toUpperCase();
  }

  if (nameParts.length > 1) {
    return `${nameParts?.[0]?.[0]}${nameParts?.[1]?.[0]}`.toUpperCase();
  }
  return "NA";
};

export function NavUser({
  user,
}: {
  user: {
    user_fullname: string;
    avatar?: string;
  };
}) {
  return (
    <NavigationMenuItem>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <SidebarMenuButton
            size="lg"
            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
          >
            <Avatar className="h-8 w-8 rounded-full">
              {typeof user.avatar === "string" ? (
                <AvatarImage src={user.avatar} />
              ) : null}
              <AvatarFallback className="bold rounded-lg text-black">
                <strong>{getFullNameInitials(user.user_fullname)}</strong>
              </AvatarFallback>
            </Avatar>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="flex gap-2 truncate font-semibold">
                <span>{user.user_fullname}</span>
              </span>
            </div>
            <ChevronsUpDown className="ml-auto size-4" />
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
          side={"bottom"}
          align="end"
          sideOffset={4}
        >
          <DropdownMenuLabel className="p-0 font-normal">
            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
              <Avatar className="h-8 w-8 rounded-full">
                {typeof user.avatar === "string" ? (
                  <AvatarImage src={user.avatar} />
                ) : null}
                <AvatarFallback className="rounded-lg">
                  {getFullNameInitials(user.user_fullname)}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="flex gap-2 truncate font-semibold">
                  <span>{user.user_fullname}</span>
                </span>
              </div>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => {
              void singOutUser();
            }}
          >
            <LogOut />
            Log out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </NavigationMenuItem>
  );
}
